import React from 'react';
function PlusForButton({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path strokeLinecap="round" d="M12 4v16M4 12h16" />
    </svg>
  );
}

export default PlusForButton;
